
import colors from '../colors.json';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },

    reversed: {
      type: Boolean,
      validate: value => value && console.warn("Reversed is deprecated, use align='start' instead")
    },

    align: {
      type: String,
      default: 'start',
      validate: value => ['left', 'right', 'start', 'end'].includes(value)
    },

    truncate: {
      type: Boolean
    },

    small: {
      type: Boolean,
      default: false
    },

    /**
     * @values colors
     */
    color: {
      /** @type {AlturaColors} */
      type: String,
      validator: value => colors.includes(value),
      default: 'primary-500'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      internalValue: this.value
    };
  },

  watch: {
    value () {
      this.internalValue = this.value;
    }
  },

  methods: {
    click () {
      this.toggle();
    },

    toggle (state) {
      this.internalValue = state ?? !this.internalValue;

      this.$emit('input', this.internalValue);
    }
  }
};
